module.exports = __webpack_public_path__ + "img/Video.1aa9d75f.svg";